import React, { useState } from 'react';
import {
  Box,
  Typography,
  TextField,
  Button,
  Paper,
  Container,
} from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';

export const Login: React.FC = () => {
  const [loginData, setLoginData] = useState({
    usernameOrEmail: '',
    password: '',
  });
  const { login } = useAuth();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await login(loginData.usernameOrEmail, loginData.password);
    } catch (error) {
      alert('Invalid username/email or password');
    }
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Typography
          variant="h1"
          component="div"
          sx={{
            flexGrow: 1,
            fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem' },
            color: 'white',
            fontWeight: 'bold',
            textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
            letterSpacing: '0.05em',
            paddingY: 1,
          }}
        >
          Dynasty Football
        </Typography>
        <Paper
          elevation={3}
          sx={{
            p: 4,
            mt: 4,
            width: '100%',
          }}
        >
          <Box
            component="form"
            onSubmit={handleLogin}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
            }}
          >
            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle1" sx={{ mb: 1, textAlign: 'left', width: '100%' }}>
                Email/Username
              </Typography>
              <TextField
                required
                fullWidth
                type="text"
                value={loginData.usernameOrEmail}
                onChange={(e) =>
                  setLoginData({
                    ...loginData,
                    usernameOrEmail: e.target.value,
                  })
                }
                InputLabelProps={{ shrink: true }}
                label=""
              />
            </Box>
            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle1" sx={{ mb: 1, textAlign: 'left', width: '100%' }}>
                Password
              </Typography>
              <TextField
                required
                fullWidth
                type="password"
                value={loginData.password}
                onChange={(e) =>
                  setLoginData({
                    ...loginData,
                    password: e.target.value,
                  })
                }
                InputLabelProps={{ shrink: true }}
                label=""
              />
            </Box>
            <Button
              type="submit"
              variant="contained"
              size="large"
              fullWidth
              sx={{ mt: 2 }}
            >
              Sign In
            </Button>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
}; 